"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { createContext, use, useMemo, useState, useTransition } from "react";
import { toast } from "sonner";
import { savePageSectionFieldAction, saveProductSectionDataAction } from "@/actions/admin";
import { NULL_STR } from "@/lib/constants";
import { logger } from "@/lib/logger";
import { invariant } from "@/lib/utils";
import { useEventCallback } from "@/ui/hooks/lifecycle";
import { debounce } from "@/ui/hooks/use-debounced-value";
import { useStartGlobalTransition } from "@/zustand/admin";
const StoreBuilderContext = createContext(null);
const debouncedToast = debounce(promise => {
  toast.promise(promise, {
    loading: "Saving…",
    success: "Saved",
    error: "Failed to save"
  });
}, 1000, {
  trailing: true
});
export const StoreBuilderContextProvider = t0 => {
  const $ = _c(23);
  const {
    children,
    path,
    productId
  } = t0;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const context = searchParams.get("context");
  const [, preselectedIdx_, preselectedPointer_] = context?.split(".") ?? [];
  Number(preselectedIdx_);
  Number(preselectedPointer_);
  const [selectedPageSection, setSelectedPageSection_] = useState(null);
  const [isTransitioning, transition] = useTransition();
  const startGlobalTransition = useStartGlobalTransition();
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = arg => {
      setSelectedPageSection_(arg);
      const newSearchParams = new URLSearchParams(searchParams);
      if (arg) {
        newSearchParams.set("context", [arg.id, arg.idx, arg.pointer].join("."));
      } else {
        newSearchParams.delete("context");
      }
      router.push(`${pathname}?${newSearchParams}`, {
        scroll: false
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setSelectedPageSection = useEventCallback(t1);
  let t2;
  if ($[4] !== path || $[5] !== productId || $[6] !== selectedPageSection || $[7] !== startGlobalTransition) {
    t2 = async t3 => {
      const {
        value: value_,
        fieldPath
      } = t3;
      console.log({
        value_,
        fieldPath
      });
      const value = value_ === NULL_STR ? null : value_;
      console.log(1, {
        value
      });
      startGlobalTransition(async () => {
        if (!selectedPageSection) {
          return;
        }
        if (path === "/product/[slug]") {
          if (!productId) {
            logger.error("Product id is missing");
            return;
          }
          transition(async () => {
            console.log({
              value
            });
            const promise = saveProductSectionDataAction({
              pageSectionIdx: selectedPageSection.idx,
              content: value,
              fieldPath,
              path,
              productId
            });
            debouncedToast(promise);
            await promise;
          });
        } else {
          transition(async () => {
            console.log({
              value
            });
            const promise_0 = savePageSectionFieldAction({
              path,
              pageSectionIdx: selectedPageSection.idx,
              group: "data",
              fieldPath,
              value: JSON.stringify(value)
            });
            debouncedToast(promise_0);
            await promise_0;
          });
        }
      });
    };
    $[4] = path;
    $[5] = productId;
    $[6] = selectedPageSection;
    $[7] = startGlobalTransition;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const saveSelectedPageSectionField = useEventCallback(t2);
  let t3;
  if ($[9] !== path || $[10] !== selectedPageSection || $[11] !== startGlobalTransition) {
    t3 = async t4 => {
      const {
        value: value_0,
        fieldPath: fieldPath_0
      } = t4;
      startGlobalTransition(async () => {
        if (!selectedPageSection) {
          return;
        }
        transition(async () => {
          console.log({
            value: value_0
          });
          await savePageSectionFieldAction({
            path,
            pageSectionIdx: selectedPageSection.idx,
            group: "theme",
            fieldPath: fieldPath_0,
            value: JSON.stringify(value_0)
          });
        });
      });
    };
    $[9] = path;
    $[10] = selectedPageSection;
    $[11] = startGlobalTransition;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const saveSelectedPageSectionThemeField = useEventCallback(t3);
  let t4;
  let t5;
  if ($[13] !== isTransitioning || $[14] !== path || $[15] !== saveSelectedPageSectionField || $[16] !== saveSelectedPageSectionThemeField || $[17] !== selectedPageSection || $[18] !== setSelectedPageSection) {
    t5 = {
      isPending: isTransitioning,
      path,
      selectedPageSection,
      setSelectedPageSection,
      saveSelectedPageSectionThemeField,
      saveSelectedPageSectionField
    };
    $[13] = isTransitioning;
    $[14] = path;
    $[15] = saveSelectedPageSectionField;
    $[16] = saveSelectedPageSectionThemeField;
    $[17] = selectedPageSection;
    $[18] = setSelectedPageSection;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  t4 = t5;
  let t6;
  if ($[20] !== children || $[21] !== t4) {
    t6 = <StoreBuilderContext value={t4}>{children}</StoreBuilderContext>;
    $[20] = children;
    $[21] = t4;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export const useStoreBuilderContext = () => {
  const context = use(StoreBuilderContext);
  invariant(context, "useStoreBuilderContext must be used within a StoreBuilderContextProvider");
  return context;
};